import { render } from "./FloorPage.vue?vue&type=template&id=bd667aa6&scoped=true"
import script from "./FloorPage.vue?vue&type=script&lang=js"
export * from "./FloorPage.vue?vue&type=script&lang=js"

import "./FloorPage.vue?vue&type=style&index=0&id=bd667aa6&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd667aa6"]])

export default __exports__